import { gql } from '@apollo/client'
import { ADMIN_AUDIT_PRODUCT_FRAGMENT } from '../fragments/AdminAuditProductFragment'

export const GET_PRODUCTS_FOR_AUDIT = gql`
  query GetProductsForAudit($input: ProductsInput) {
    products(input: $input) {
      results {
        ...AdminAuditProduct
      }
    }
  }
  ${ADMIN_AUDIT_PRODUCT_FRAGMENT}
`
